module.exports = __webpack_public_path__ + "img/3.6cb88d3c.png";